"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = exports.CommentActionTypeEnum = void 0;
const typeorm_1 = require("typeorm");
const job_1 = require("./job");
const user_role_enum_1 = require("./user-role-enum");
const product_order_1 = require("./product-order");
const job_cancellation_1 = require("./job-cancellation");
var CommentActionTypeEnum;
(function (CommentActionTypeEnum) {
    CommentActionTypeEnum["EMAIL"] = "email";
    CommentActionTypeEnum["PHONE"] = "phone";
    CommentActionTypeEnum["FORWARDED"] = "forwarded";
    CommentActionTypeEnum["KVA_SENT"] = "kva_sent";
    CommentActionTypeEnum["GENERIC"] = "generic";
    CommentActionTypeEnum["CUSTOMER_SIGNATURE"] = "customer_signature";
})(CommentActionTypeEnum = exports.CommentActionTypeEnum || (exports.CommentActionTypeEnum = {}));
let Comment = class Comment {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], Comment.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Index)('idx_trgm_comment_msg', { synchronize: false }),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Comment.prototype, "message", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], Comment.prototype, "visibleForRoles", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: CommentActionTypeEnum,
        default: CommentActionTypeEnum.GENERIC,
    }),
    __metadata("design:type", String)
], Comment.prototype, "actionType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
    }),
    __metadata("design:type", String)
], Comment.prototype, "creatorRole", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Comment.prototype, "creatorSfid", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], Comment.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    __metadata("design:type", Date)
], Comment.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    __metadata("design:type", Date)
], Comment.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => job_1.Job, (job) => job.comments, {
        onDelete: 'CASCADE',
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_api_id',
        referencedColumnName: 'apiId',
    }),
    __metadata("design:type", job_1.Job)
], Comment.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => product_order_1.ProductOrder, (productOrder) => productOrder.comments),
    __metadata("design:type", Array)
], Comment.prototype, "productOrders", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => job_cancellation_1.JobCancellation, (cancellation) => cancellation.comment),
    __metadata("design:type", job_cancellation_1.JobCancellation)
], Comment.prototype, "cancellation", void 0);
Comment = __decorate([
    (0, typeorm_1.Entity)('comment', {
        schema: 'public',
    })
], Comment);
exports.Comment = Comment;
//# sourceMappingURL=comment.js.map